<div class="d-flex gap-1 px-1 w-fit">
  <broker-warning-svg *ngIf="isWarning"></broker-warning-svg>
  <broker-decline-svg *ngIf="isExpired"></broker-decline-svg>
  <p class="m-0" [style.height]="'16px'" [style.line-height]="'18px'" [style.color]="isExpired ? 'red' : ''">
    {{ creditCheckExpiryDateKey | translate: lang:{ days: days } }}
  </p>
</div>
